import { Check } from "lucide-react";
import LandingPageShell from "@/components/landing-page/layout/LandingPageShell";
import PageHero from "@/components/landing-page/PageHero";
import FinalCta from "@/components/landing-page/home/FinalCta";
import { workflowSteps } from "@/components/landing-page/home/EnterpriseWorkflow";
import EnterpriseJourney from "@/components/landing-page/home/EnterpriseJourney";
import Reveal from "@/components/ui/Reveal";

export default function HowItWorksPage() {
  return (
    <LandingPageShell>
      <PageHero
        eyebrow="How it works"
        title="Assess. Personalize. Practice. Validate. Measure."
        description="Five steps that take your workforce from wherever they are today to AI capability you can verify and measure."
      />

      <section className="bg-white px-margin-mobile md:px-margin-desktop pb-size-xl">
        <div className="max-w-[1440px] mx-auto">
          <EnterpriseJourney />
        </div>
      </section>

      <section className="bg-mkt-surface px-margin-mobile md:px-margin-desktop py-size-xl">
        <div className="relative max-w-4xl mx-auto">
          <span
            aria-hidden="true"
            className="absolute left-6 top-6 bottom-6 w-px bg-mkt-primary/30"
          />
          <ol className="relative list-none pl-0 ml-0 flex flex-col gap-size-lg">
            {workflowSteps.map(
              ({ id, label, Icon, title, body, points }, index) => (
                <li key={id} id={id} className="scroll-mt-28 relative pl-20">
                  <span className="absolute left-0 top-0 flex h-12 w-12 items-center justify-center rounded-full bg-mkt-primary-container text-mkt-on-primary font-headline-md font-bold ring-[6px] ring-mkt-surface">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <Reveal>
                    <article className="rounded-xl border border-mkt-primary/20 bg-white p-size-md sm:p-size-lg shadow-[0_4px_16px_rgba(0,60,185,0.10)]">
                      <div className="flex items-center justify-between gap-size-sm mb-size-sm">
                        <span className="font-label-md text-label-md uppercase tracking-widest text-mkt-primary">
                          {label}
                        </span>
                        <Icon
                          aria-hidden="true"
                          strokeWidth={1.5}
                          className="h-6 w-6 text-mkt-primary"
                        />
                      </div>
                      <h2 className="font-headline-lg text-headline-sm md:text-headline-md text-mkt-inarax-black mb-size-sm">
                        {title}
                      </h2>
                      <p className="font-body-lg text-body-lg text-mkt-on-surface-variant mb-size-md">
                        {body}
                      </p>
                      <ul className="list-none pl-0 ml-0 grid grid-cols-1 sm:grid-cols-3 gap-size-sm border-t border-mkt-outline-variant/40 pt-size-md">
                        {points.map((point) => (
                          <li
                            key={point}
                            className="flex items-start gap-size-xs font-body-md text-body-md text-mkt-on-surface"
                          >
                            <Check
                              aria-hidden="true"
                              className="mt-0.5 h-5 w-5 shrink-0 text-mkt-primary"
                            />
                            {point}
                          </li>
                        ))}
                      </ul>
                    </article>
                  </Reveal>
                </li>
              ),
            )}
          </ol>
        </div>
      </section>

      <FinalCta />
    </LandingPageShell>
  );
}
